"use strict";

require("core-js/modules/es6.function.name");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterSocialIconLinks = void 0;

var _react = _interopRequireDefault(require("react"));

var _box = _interopRequireDefault(require("@waglabs/box"));

var _link = _interopRequireDefault(require("@waglabs/link"));

var _FacebookLogoIcon = require("./FacebookLogoIcon");

var _InstagramLogoIcon = require("./InstagramLogoIcon");

var _TwitterLogoIcon = require("./TwitterLogoIcon");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var socialIcons = [{
  name: 'facebook',
  url: 'https://facebook.com/wagwalking',
  iconComponent: _FacebookLogoIcon.FacebookLogoIcon
}, {
  name: 'instagram',
  url: 'https://instagram.com/wag',
  iconComponent: _InstagramLogoIcon.InstagramLogoIcon
}, {
  name: 'twitter',
  url: 'https://twitter.com/wagwalking',
  iconComponent: _TwitterLogoIcon.TwitterLogoIcon
}];

var FooterSocialIconLinks = function FooterSocialIconLinks(props) {
  return _react["default"].createElement(_box["default"], props, socialIcons.map(function (_ref, index) {
    var url = _ref.url,
        name = _ref.name,
        IconComponent = _ref.iconComponent;
    var isLastItem = index === socialIcons.length - 1;
    return _react["default"].createElement(_link["default"], {
      key: name,
      href: url,
      target: "_blank"
    }, _react["default"].createElement(IconComponent, {
      fontSize: "1.875rem",
      mr: isLastItem ? 0 : ['20px', '24px']
    }));
  }));
};

exports.FooterSocialIconLinks = FooterSocialIconLinks;